import { COLOR_PALETTE } from '@inflearn/ds-react';
import { Spoiler } from '@inflearn/ds-react';

export const TermSpoiler = ({ termHtml }: { termHtml: string }) => (
  <Spoiler
    maxHeight={216}
    showLabel="더보기"
    hideLabel="숨기기"
    px={12}
    pt={12}
    pb={8}
    css={{
      position: 'relative',
      borderColor: COLOR_PALETTE.gray[2],
      borderWidth: 1,
      borderStyle: 'solid',
      borderRadius: 8,
    }}>
    <div
      dangerouslySetInnerHTML={{
        __html: termHtml,
      }}
    />
  </Spoiler>
);
